module.exports = __webpack_public_path__ + "static/media/2016 - 2017 theme logo.48f8166c.jpg";